import { Base64, SoledadUtils } from './../../lib/helpers/utils';

export interface Bill {
    cliente: string;
    clienteNombre: string;
    cargoabono: string;

    numero: number;
    serie: string;
    fecha: string;
    fechaDate: Date;

    neto: number;
    bruto: number;
    URL_PDF: string;
}

export class Bill {

    static transformFromApi(apiData: Object): Bill {
        const obj = new Bill();
        obj.cargoabono = apiData['FA_CARGOABONO'];
        obj.cliente = apiData['FA_CLIENTE'];
        obj.clienteNombre = apiData['FA_CLIENTENOMBRE'];
        obj.fecha = apiData['FA_FECHA'];
        obj.fechaDate = SoledadUtils.dateTimeParse(apiData['FA_FECHADATE']);
        obj.bruto = (parseFloat(apiData['FA_BRUTO']) + 0.0) * ((apiData['FA_CARGOABONO'] !== 'ABONO') ? 1 : -1);
        obj.neto = (parseFloat(apiData['FA_NETO']) + 0.0) * ((apiData['FA_CARGOABONO'] !== 'ABONO') ? 1 : -1);
        obj.numero = apiData['FA_NUMERO'];
        obj.serie = apiData['FA_SERIE'];
        obj.URL_PDF = '';
        // obj.pdf = apiData['FA_URL_PDF'];
        return obj;
    }
}
